const sizeChart = document.getElementById('sizeChartPopup');
const sizeChartOpen = document.getElementById('openSizeChart');
const sizeChartClose = document.getElementById('closeSizeChart');

function openVideo(){
    document.querySelector('.video-container').classList.toggle('hidden');
}

if(sizeChart && sizeChartOpen && sizeChartClose){
    sizeChartClose.addEventListener('click', function(){
        sizeChart.classList.remove('open');
        document.documentElement.classList.remove('disable-scroll');
    });
}

function openSizeChart(){
    sizeChart.classList.add('open');
    document.documentElement.classList.add('disable-scroll');
}

const lookPopup = document.getElementById('lookPopup');
const closeLook = document.getElementById('closeLook');

if(closeLook && lookPopup){
    closeLook.addEventListener('click', function(){
        lookPopup.classList.remove('open');
        document.documentElement.classList.remove('disable-scroll');
    });

    lookPopup.addEventListener('click', (e) => {
        if(e.target == lookPopup){
            lookPopup.classList.remove('open');
            document.documentElement.classList.remove('disable-scroll');
        }
    });
}

function openLook(){
    lookPopup.classList.add('open');
    document.documentElement.classList.add('disable-scroll');
}

const waitingListPopup = document.getElementById('waitingListPopup');
const waitingListPopupOpen = document.getElementById('waitingListPopupOpen');
const waitingListPopupClose = document.getElementById('waitingListPopupClose');

if(waitingListPopup && waitingListPopupClose && waitingListPopupOpen){
    waitingListPopupClose.addEventListener('click', function(){
        waitingListPopup.classList.remove('open');
        document.documentElement.classList.remove('disable-scroll');
    });

    waitingListPopup.addEventListener('click', (e) => {
        if(e.target == waitingListPopup){
            waitingListPopup.classList.remove('open');
            document.documentElement.classList.remove('disable-scroll');
        }
    });
}

function openWaitingListPopup(){
    waitingListPopup.classList.add('open');
    document.documentElement.classList.add('disable-scroll');
}